import './main.css'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './i18n' // Import i18n configuration
import { installFetchInterceptor } from './utils/fetchInterceptor'
import { runUploadIdbMigrationOnce } from './utils/uploadIdbMigration'
import posthog from 'posthog-js'
import { PostHogProvider } from '@posthog/react'

// Install fetch interceptor early, before React renders
installFetchInterceptor()

// One-time clear of legacy upload IndexedDB to prevent duplicate uploads (plan: Upload Migration Risk Analysis)
runUploadIdbMigrationOnce().catch(() => {})


const posthogKey = process.env.VITE_PUBLIC_POSTHOG_KEY
const posthogHost = process.env.VITE_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com'

if (posthogKey) {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    defaults: '2025-05-24',
    loaded: (posthog) => {
      if (process.env.NODE_ENV === 'development') posthog.debug()
    }
  })
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  </React.StrictMode>
)
